import * as v from 'valibot';
import { VALIDATION } from '../constants.js';

export function createSignupSchema() {
  return v.pipe(
    v.object({
      category: v.pipe(v.string(), v.nonEmpty('Category is required')),
      teamSize: v.pipe(v.string(), v.nonEmpty('Team size is required')),
      bookingMethod: v.pipe(
        v.string(),
        v.nonEmpty('Booking method is required'),
      ),
      otherSoftware: v.optional(v.string()),
      firstName: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('First name is required'),
        v.maxLength(
          VALIDATION.MAX_NAME_LENGTH,
          'First name must be at most 50 characters',
        ),
      ),
      lastName: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Last name is required'),
        v.maxLength(
          VALIDATION.MAX_NAME_LENGTH,
          'Last name must be at most 50 characters',
        ),
      ),
      businessName: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Business name is required'),
        v.maxLength(
          VALIDATION.MAX_FIELD_LENGTH,
          'Business name must be at most 100 characters',
        ),
      ),
      phoneNumber: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Phone number is required'),
        v.maxLength(
          VALIDATION.MAX_PHONE_LENGTH,
          'Phone number must be at most 50 characters',
        ),
      ),
      email: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Email is required'),
        v.maxLength(
          VALIDATION.MAX_FIELD_LENGTH,
          'Email must be at most 100 characters',
        ),
        v.email('Invalid email address'),
      ),
      password: v.pipe(
        v.string(),
        v.trim(),
        v.minLength(
          VALIDATION.PASSWORD_MIN_LENGTH,
          `Password must be at least ${VALIDATION.PASSWORD_MIN_LENGTH} characters`,
        ),
        v.maxLength(
          VALIDATION.MAX_FIELD_LENGTH,
          'Password must be at most 100 characters',
        ),
        v.check(
          (val) => /[a-z]/.test(val),
          'Password must contain at least one lowercase letter',
        ),
        v.check(
          (val) => /[A-Z]/.test(val),
          'Password must contain at least one uppercase letter',
        ),
        v.check(
          (val) => /[0-9]/.test(val),
          'Password must contain at least one number',
        ),
        v.check(
          (val) => VALIDATION.SPECIAL_CHARACTERS.test(val),
          'Password must contain at least one special character',
        ),
      ),
      referralId: v.optional(v.string()),
      promoCode: v.optional(v.pipe(v.string(), v.trim())),
      hasTerms: v.pipe(
        v.boolean(),
        v.literal(true, 'You must accept the terms & conditions'),
      ),
      countryCode: v.optional(v.string()),
      currency: v.optional(v.string()),
      timeZone: v.optional(v.number()),
      gRecaptchaResponse: v.pipe(
        v.string(),
        v.nonEmpty('reCAPTCHA is required'),
      ),
    }),
    v.forward(
      v.check((data) => {
        const hasAllRegionFields =
          data.countryCode && data.currency && data.timeZone;
        const hasNoRegionFields =
          !data.countryCode && !data.currency && !data.timeZone;
        return hasAllRegionFields || hasNoRegionFields;
      }, 'Either fill in all: country, currency, time zone fields, or leave them all blank.'),
      ['countryCode'],
    ),
  );
}

export function createPasswordRules() {
  return [
    {
      label: `Minimum ${VALIDATION.PASSWORD_MIN_LENGTH} characters`,
      test: (value) => value.length >= VALIDATION.PASSWORD_MIN_LENGTH,
    },
    {
      label: 'One lowercase letter',
      test: (value) => /[a-z]/.test(value),
    },
    {
      label: 'One uppercase letter',
      test: (value) => /[A-Z]/.test(value),
    },
    {
      label: 'One number',
      test: (value) => /[0-9]/.test(value),
    },
    {
      label: 'One special character',
      test: (value) => VALIDATION.SPECIAL_CHARACTERS.test(value),
    },
  ];
}
